export const formatEmployeeId = (value) => {
  if (value === null || value === undefined) {
    return '';
  }

  const normalized = String(value).trim();

  if (!normalized) {
    return '';
  }

  return normalized.replace(/^EMP(-?)/i, 'GSM$1');
};

